// Entry point: styles, shell, routes, first-launch welcome.
import '@fontsource-variable/inter';
import './styles/app.css';
import './styles/ride.css';
import './styles/tour.css';
import './styles/setup.css';
import { start, refresh } from './ui/router.js';
import { registerRoutes } from './ui/routes.js';
import { mountShell } from './ui/shell.js';
import { watchFriendRequests } from './data/friends.js';
import { startTutorials } from './ui/tour/index.js';
import { startSync } from './data/sync.js';
import { isLoggedIn, onAuthChange } from './data/api.js';
import { startCulture } from './data/culture.js';
import { onCultureChange, loadDict, lang } from './i18n/index.js';
import { startTheme } from './ui/theme.js';
import { consentGate } from './ui/legal.js';
import { registerFlagFont } from './render/flags.js';
import { offerResume, forgetResume } from './ui/resume.js';
import { music } from './audio/music/index.js';

registerRoutes();

startTheme();
startCulture();
registerFlagFont();
// the French dictionary is its own chunk: in place before the first screen when the player reads French
await loadDict(lang());
mountShell();
start();
// the soundtrack: the menu's piece once signed in, after the first gesture on the page
music.attach(document);
music.set(isLoggedIn() ? { kind: 'menu' } : { kind: 'silent' });
window.__gvMusic = music; // read by the end-to-end test: the menu's piece plays after the first click
// Language, time zone or clock changed: the current screen is redrawn with the new formats.
onCultureChange(() => refresh());
startSync();
watchFriendRequests();
startTutorials();
// signed in or out: the router swaps the welcome screen and the app (a token refresh changes nothing)
let signedIn = isLoggedIn();
// An account that has not accepted the current terms (older account, Google or Strava sign-up) is asked before anything
// else, except on the legal pages themselves, which stay readable: the gate comes back as soon as the player leaves them.
// Then a ride a closed or reloaded page interrupted is offered again, once (ADR 0028).
const gate = async () => { if (isLoggedIn() && (await consentGate())) void offerResume(); };
void gate();
document.addEventListener('route', () => void gate());
onAuthChange(s => { if (!s) forgetResume(); if (!!s !== signedIn) { signedIn = !!s; music.set(signedIn ? { kind: 'menu' } : { kind: 'silent' }); refresh(); } });
